import React from 'react';
import { StyleSheet, View } from 'react-native';

import { ds } from './lib/design.system';

export type RadioItemProps = {
    selected: boolean;
    color?: string;
};

export function RadioItem({ selected, color }: RadioItemProps) {
    return (
        <View
            style={[
                radioStyles.defaultStyles,
                selected && {
                    ...radioStyles.selected,
                    borderColor: color ?? ds.colorValue.background.neutral.inverse,
                },
            ]}
        />
    );
}

const radioStyles = StyleSheet.create({
    defaultStyles: {
        width: 20,
        height: 20,
        borderRadius: 10,
        borderCurve: 'continuous',
        borderWidth: 2,
        alignItems: 'center',
        justifyContent: 'center',
        borderColor: ds.colorValue.icon.secondary,
    },
    selected: {
        borderColor: ds.colorValue.background.neutral.inverse, // not a border, but a selected indicator
        borderWidth: 6,
    },
});
